import classNames from 'classnames';

import { Text } from '@sravni/react-design-system/lib/Typography';

import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { open } from '@src/helpers/navigationHelper';

import styles from './FullDealEntryPointDisclaimer.module.scss';

export function FullDealEntryPointDisclaimer({ className, link }: { className: string; link: string }) {
  const handleClick = () => {
    open({ href: link, target: '_blank', features: 'noopener' });
  };

  return (
    <Text className={classNames(styles.disclaimer, className)}>
      Первый заём бесплатно при возврате в срок.{UNBREAKABLE_SEPARATOR}
      <a onClick={handleClick}>Подробнее</a>
    </Text>
  );
}
